define('views/shop/instore/merchants_see_all_btn',[
    'views/_base/baseview',
    'text!views/shop/instore/merchants_see_all_btn.html',
], function (BaseView, Template) {
    'use strict';

    return BaseView.extend({
        className: 'merchants-see-all-container',
        tagName : 'li',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click': 'showFullMerchantView'
        },
        initialize: function(options){
            options = options || {};

            this.shop_view = options.shop_view

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            return this;
        },

        showFullMerchantView: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }
            
            pf.navigate('#shop/nearby');

            // this.shop_view.seeMoreClickFromPreview();
            // Temporary fix
            setTimeout(function(){
                google.maps.event.trigger(pf.maps.current, 'resize');
            },6000);
        },

        close: function(){}
    });
});

